// Single working admin URL. The bundle ships to two hosts (worker host +
// Contember Cloud); only the worker host serves our /rpc route, so admins
// landing on Contember Cloud must be bounced to the canonical worker host.
//
// `VITE_ADMIN_CANONICAL_HOST` is baked at build time from the deploy's
// `SVET_NEZISKOVEK_RPC_URL` (the worker host). It is intentionally empty in
// local dev, so dev (and any preview without the var) never redirects.

function canonicalHost(): string {
	const raw = import.meta.env.VITE_ADMIN_CANONICAL_HOST?.trim()
	if (!raw) return ''
	const cleaned = raw.replace(/\/+$/, '')
	try {
		return new URL(cleaned.includes('://') ? cleaned : `https://${cleaned}`).host
	} catch {
		return cleaned
	}
}

/**
 * Hosts that serve the admin next to the canonical one (Cloudflare for SaaS
 * custom hostnames routed to the same worker, see oblaka.ts `adminAliasHosts`).
 * `VITE_ADMIN_ALIAS_HOSTS` is comma-separated; empty means every other host
 * bounces to the canonical one.
 */
function allowedAliasHosts(): string[] {
	const raw = import.meta.env.VITE_ADMIN_ALIAS_HOSTS?.trim() ?? ''
	return raw.split(',').map((h: string) => h.trim()).filter(Boolean)
}

/**
 * If we're on a non-canonical host in production, navigate to the same path on
 * the canonical worker host and return `true` (caller should not boot the app).
 * Returns `false` when no redirect is needed (dev, missing var, or already on
 * the canonical host).
 */
export function redirectToCanonicalHost(): boolean {
	if (!import.meta.env.PROD) return false
	if (typeof window === 'undefined') return false

	const host = canonicalHost()
	if (!host || window.location.host === host) return false
	if (allowedAliasHosts().includes(window.location.host)) return false

	const target = new URL(window.location.href)
	target.protocol = 'https:'
	target.host = host
	window.location.replace(target.toString())
	return true
}
